import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  useDispatch,
  useSelector
} from 'react-redux';
import RenewalForm from './RenewalForm';
import RenewalAdminForm from './RenewalAdminForm';
import { getAdpDefaultFields } from '../../redux/action';

const RenewalAdpForm = ({ location }) => {
  const { state } = location || {};
  const { isAdminForm, myApplication } = state || {};
  const dispatch = useDispatch();
  const adpSettings = useSelector(states => states?.permitManagement?.adpSettings);

  const isAdminFormEnable = adpSettings?.allow_admin_to_submit_driver_application || isAdminForm;

  useEffect(() => {
    dispatch(getAdpDefaultFields());
  }, [dispatch]);

  return (
    <div>
      {isAdminFormEnable ? (
        <RenewalAdminForm />
      ) : (
        <RenewalForm myApplication={myApplication} />
      )}
    </div>
  );
};

RenewalAdpForm.propTypes = {
  location: PropTypes.shape({}).isRequired
};

export default RenewalAdpForm;
